/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { InsuranceRelationResponse } from './api.schemas';

import { api } from '../util/http';

export const getInsuranceRelations = (signal?: AbortSignal) => {
  return api<InsuranceRelationResponse[]>({
    url: `/api/insurance-relations`,
    method: 'GET',
    signal,
  });
};

export const getGetInsuranceRelationsQueryKey = () => {
  return [`/api/insurance-relations`] as const;
};

export const getGetInsuranceRelationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getInsuranceRelations>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getInsuranceRelations>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetInsuranceRelationsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getInsuranceRelations>>> = ({ signal }) =>
    getInsuranceRelations(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getInsuranceRelations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetInsuranceRelationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInsuranceRelations>>
>;
export type GetInsuranceRelationsQueryError = unknown;

export function useGetInsuranceRelations<
  TData = Awaited<ReturnType<typeof getInsuranceRelations>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getInsuranceRelations>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInsuranceRelations>>,
          TError,
          Awaited<ReturnType<typeof getInsuranceRelations>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetInsuranceRelations<
  TData = Awaited<ReturnType<typeof getInsuranceRelations>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getInsuranceRelations>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInsuranceRelations>>,
          TError,
          Awaited<ReturnType<typeof getInsuranceRelations>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetInsuranceRelations<
  TData = Awaited<ReturnType<typeof getInsuranceRelations>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getInsuranceRelations>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetInsuranceRelations<
  TData = Awaited<ReturnType<typeof getInsuranceRelations>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getInsuranceRelations>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetInsuranceRelationsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
